import { writable } from "svelte/store";
import { onAuthStateChanged, type Auth, type User } from "firebase/auth";
import { docStore } from "./firestore";
import type { Firestore } from "firebase/firestore";
import type { NucampUser } from "$lib/datamodel";
import { syncUser } from "../services/user";


/**
 * @param  {Auth} auth firebase auth instance
 * @param  {Firestore} db firebase firestore instance
 * @param  {any} startWith optional default data. Useful for server-side cookie-based auth
 * @returns a store with the current firebase user
 */
export function userStore(auth: Auth, db: Firestore, startWith = null) {
  let unsubscribe: () => void;

  // Fallback for SSR
  if (!globalThis.window) {
    const { subscribe } = writable(startWith);
    return {
      subscribe,
    };
  }

  // Fallback for missing SDK
  if (!auth) {
    console.warn(
      "Firebase Auth is not initialized. Are you missing FirebaseApp as a parent component?"
    );
    const { subscribe } = writable(null);
    return {
      subscribe,
    };
  }

  const { subscribe } = writable<User | NucampUser | undefined>(auth?.currentUser ?? undefined, (set) => {
    unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user?.uid) {
        docStore(db, `users/${user.uid}`).subscribe((nucampUser) => {
          if (nucampUser) {
            if (!nucampUser?.uid) {
              nucampUser.uid = user.uid;
            }
            syncUser(nucampUser);
            set(nucampUser as NucampUser);
          } else {
            set(user as User);
          }
        });
      } else {
        set(user as User);
      }
    });

    return () => unsubscribe();
  });

  return {
    subscribe,
  };
}